var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.rowIterateNumber),function(n){return _c('div',{key:n},[_c('div',{staticClass:"m-b-5"},[_c('b-skeleton',{attrs:{"height":"20px","width":"50%"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }